'use client';

import { Link } from 'react-router-dom';
import { ArrowLeft, Utensils, Phone, MapPin } from 'lucide-react';
import Footer from '@/components/Footer';


const MARMITAS = [
  { name: "A Cantina", address: "Rua Presidente Kennedy esquina com Rua Presidente Castelo Branco, Centro", whatsapp: "https://wa.me/5545991523513" },
  { name: "Mega Beer Restaurante (fogão a lenha)", address: "Avenida Augusto Gomes de Oliveira, PR-471, 760, Alto Alegre", whatsapp: "https://wa.me/5545991329934" },
  { name: "Restaurante Costa e Silva", address: "Rua Presidente Costa e Silva, 432, Bairro Menino Deus", whatsapp: "https://wa.me/554532341380" },
  { name: "Restaurante Tempero Bom", address: "Av. Augusto Gomes de Oliveira, 700", whatsapp: "https://wa.me/5545991240950" },
].sort((a, b) => a.name.localeCompare(b.name));

export default function MarmitasPage() {
  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-rose-200 selection:text-rose-900">
      {/* Header */}
      <header className="bg-gradient-to-r from-red-600 to-rose-700 text-white shadow-lg">
        <div className="max-w-4xl mx-auto px-4 py-12 md:py-20 text-center space-y-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 px-6 py-3 rounded-2xl text-white font-black uppercase tracking-tighter italic transition-all hover:-translate-x-1 active:scale-95 mb-8 group shadow-lg"
          >
            <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
            Voltar para o Início
          </Link>
          <h1 className="text-3xl md:text-5xl font-black tracking-tighter uppercase italic">
            Marmitas <br className="md:hidden" />
            <span className="text-rose-200">Catanduvas PR</span>
          </h1>
          <p className="text-rose-100 text-lg md:text-xl font-medium max-w-2xl mx-auto">
            Fome? Ligue agora e peça sua marmita.
          </p>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 -mt-8 pb-20">
        <div className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-2xl border border-slate-100">
          <div className="flex items-center gap-3 mb-10">
            <div className="bg-rose-100 p-3 rounded-2xl">
              <Utensils className="w-8 h-8 text-rose-600" />
            </div>
            <div>
              <h2 className="text-2xl font-black text-slate-800 uppercase tracking-tighter italic">Lista de Empresas</h2>
              <p className="text-slate-500 font-bold text-sm">Clique no botão para pedir pelo WhatsApp</p>
            </div>
          </div>

          <div className="space-y-6">
            {MARMITAS.map((item, i) => (
              <div key={i} className="bg-slate-50 rounded-3xl p-6 border border-slate-100 group hover:bg-white hover:shadow-xl transition-all">
                <h3 className="text-2xl font-black text-slate-800 uppercase tracking-tighter italic mb-4">{item.name}</h3>
                <p className="text-slate-600 text-sm font-bold flex items-start gap-2 mb-6">
                  <MapPin className="w-5 h-5 flex-shrink-0 text-rose-500" />
                  {item.address}
                </p>

                <a 
                  href={item.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white py-4 rounded-2xl font-black uppercase tracking-tighter italic transition-all active:scale-95 shadow-lg shadow-emerald-200"
                >
                  <Phone className="w-5 h-5" />
                  Pedir pelo WhatsApp
                </a>
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
